import Accordion from 'accordion-js';

function accordionFunction() {
  const accordionsContainer = Array.from(
    document.querySelectorAll('.accordion-container')
  );

  accordionsContainer.forEach((container) => {
    if (!container.classList.contains('initialized')) {
      new Accordion(container, {
        duration: 400,
        showMultiple: true,
      });
      container.classList.add('initialized');
    }
  });

  const accordions = document.querySelectorAll('.accordion');
  if (accordions) {
    accordions.forEach((accordionItem) => {
      const subRows = accordionItem.querySelector('.accordion__sub-rows');
      if (subRows) {
        subRows.removeAttribute('role');
      }
    });
  }

  const headers = document.querySelectorAll('.accordion-toggle');
  headers.forEach((header) => {
    header.addEventListener('focus', () => {
      const accordionItem = header.closest('.accordion');
      const links = accordionItem.querySelectorAll('.accordion__sub-rows a');
      const iframes = accordionItem.querySelectorAll(
        '.accordion__sub-rows figure iframe'
      );
      const isActive = accordionItem.classList.contains('is-active');

      links.forEach((link) => {
        link.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      iframes.forEach((iframe) => {
        iframe.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        accordionFunction();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  accordionFunction();
});
